import {
  ReportSection,
  ReportSectionConfigurationBase,
  ReportSectionDataSection,
  ReportSectionPlacementType,
  ReportType,
  ReportViewModelSection
} from '@capital-access/reporting/common';
import { DisclosureDataModel } from './disclosure.model';

export class DisclosureConfiguration extends ReportSectionConfigurationBase {
  typeName = 'DisclosureConfiguration';
  nodataLocalizationKeyName = 'bnyDepositoryDisclosure';
  readonly reportSection = ReportSection.Disclosure;
  override readonly placementType = ReportSectionPlacementType.Static;
  readonly applicableReportTypes = [ReportType.BnyManagementReport, ReportType.OwnershipAnalyticsReport];

  get reportViewModelSections(): ReportViewModelSection[] {
    if (this.appliedReportType === ReportType.OwnershipAnalyticsReport) {
      return [ReportViewModelSection.OwnershipAnalyticsReport_Disclosure];
    } else if (this.appliedReportType === ReportType.BnyManagementReport) {
      return [ReportViewModelSection.BnyManagementReport_Disclosure];
    } else {
      throw new Error('Report Type not supported');
    }
  }
  maxSize = 4;
  defaultSize = 4;
  minSize = 0;
  override disabledLayoutWidthControl = true;
  override disableSectionSelection = true;
  name = 'disclosure';
  displayName = 'Disclosure';
  canConfigure = true;
  order = 15;
  readonly availableDataSections: ReportSectionDataSection[] = [];
}

export interface DisclosureComponentData {
  [ReportViewModelSection.BnyManagementReport_Disclosure]: {
    disclosureDataModel: DisclosureDataModel;
  };
  [ReportViewModelSection.OwnershipAnalyticsReport_Disclosure]: {
    disclosureDataModel: DisclosureDataModel;
  };
}
